/**
 * Slack Logo SVG Component
 *
 * Slack brand logo (simplified mark)
 */

interface SlackLogoProps {
  className?: string;
}

export function SlackLogo({ className }: SlackLogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Top-left (green) */}
      <path
        d="M8.5 18.5a2.5 2.5 0 1 1-2.5-2.5h2.5v2.5zm1.25 0a2.5 2.5 0 1 1 5 0v6.25a2.5 2.5 0 1 1-5 0v-6.25z"
        fill="#2EB67D"
      />
      {/* Top-right (red) */}
      <path
        d="M13.5 8.5a2.5 2.5 0 1 1 2.5-2.5v2.5h-2.5zm0 1.25a2.5 2.5 0 1 1 0 5H7.25a2.5 2.5 0 1 1 0-5h6.25z"
        fill="#E01E5A"
      />
      {/* Bottom-right (yellow) */}
      <path
        d="M23.5 13.5a2.5 2.5 0 1 1 2.5 2.5h-2.5v-2.5zm-1.25 0a2.5 2.5 0 1 1-5 0V7.25a2.5 2.5 0 1 1 5 0v6.25z"
        fill="#ECB22E"
      />
      {/* Bottom-left (blue) */}
      <path
        d="M18.5 23.5a2.5 2.5 0 1 1-2.5 2.5v-2.5h2.5zm0-1.25a2.5 2.5 0 1 1 0-5h6.25a2.5 2.5 0 1 1 0 5H18.5z"
        fill="#36C5F0"
      />
    </svg>
  );
}
